export default __webpack_public_path__ + "static/media/power.edddbbe5.svg";